// extracted by mini-css-extract-plugin
module.exports = {"container":"input-fuel-amount_container__2JBhs","radio":"input-fuel-amount_radio__3O2qu","error":"input-fuel-amount_error__kXOaY"};